/** Session invalidation codes returned by the API on 401 (`@apuestes/types` SessionErrorCode). */
export const SESSION_ERROR_CODES = [
  'SESSION_REPLACED',
  'DEVICE_REVOKED',
  'REAUTH_REQUIRED',
] as const;

export type SessionErrorCode = (typeof SESSION_ERROR_CODES)[number];

/** Login endpoints: their 401/403 are handled on the auth screen, never global logout. */
export const AUTH_LOGIN_URLS = [
  '/auth/email/register',
  '/auth/email/login',
  '/auth/google/login',
  '/auth/apple/login',
] as const;

/** Endpoints that skip generic silent logout on 401/403 (legacy behaviour). */
export const AUTH_ENDPOINTS_SKIP_GENERIC_LOGOUT = [
  ...AUTH_LOGIN_URLS,
  '/auth/token/refresh',
  '/auth/roles/attach',
  '/request-tipster-types',
] as const;

export function isSessionErrorCode(code: unknown): code is SessionErrorCode {
  return (
    typeof code === 'string' &&
    SESSION_ERROR_CODES.includes(code as SessionErrorCode)
  );
}

export function getSessionErrorFromResponseData(
  data: unknown,
): SessionErrorCode | undefined {
  if (data && typeof data === 'object' && 'error' in data) {
    const code = (data as { error?: unknown }).error;
    return isSessionErrorCode(code) ? code : undefined;
  }
  return undefined;
}

export function urlMatchesAny(url: string, patterns: readonly string[]): boolean {
  return patterns.some(pattern => url.includes(pattern));
}
